/**
 * StreamOutputDTO entity class
 */

/**
 * StreamOutputDTOFactory
 * returns StreamOutputDTO entity class
 *
 * @class StreamOutputDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamOutputDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamOutputDTOFactory
 */
/* @ngInject */
export default function StreamOutputDTOFactory (Entity) {
  /* === StreamOutputDTO class === */

  /**
   * StreamOutputDTO model
   *
   * @class StreamOutputDTO
   * @classdesc StreamOutputDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamOutputDTO entity fields
   * @return {models.StreamOutputDTO} StreamOutputDTO entity
   */
  function StreamOutputDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamOutputDTO.prototype = Object.create(Entity.prototype)
  StreamOutputDTO.prototype.constructor = StreamOutputDTO

  /* === StreamOutputDTO instance methods & fields === */

  Object.assign(StreamOutputDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamOutputDTO#
     * @type {Object}
     */
    _fields: {
      externalId: String,
      uris: ['StreamOutputUriDTO'],
      multiProfile: Boolean,
      drm: 'DRMDTO'
    }
  })

  /* "outputs": [
        {
          "externalId": "string",
          "uris": [
            {
              "uri": "string",
              "type": "RTMP"
            }
          ],
          "multiProfile": true,
          "drm": {
            "providerName": "string",
            "systems": [
              "FAIRPLAY"
            ]
          }
        }
      ], */

  /**/

  /* === StreamOutputDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamOutputDTO, Entity)
  StreamOutputDTO._name = 'StreamOutputDTO'
  StreamOutputDTO.init()

  return StreamOutputDTO
}
